import { STORAGE_TOKEN } from '../constants/storage'

export const getStorage = local => (local ? localStorage : sessionStorage)

export const clearLocalStorage = () => {
  localStorage.clear()
  console.warn('localStorage has been cleared')
}

/**
 ** Web Storage coerces everything to a string, so a token that was written while it was
 ** undefined/null reads back as the literal 'undefined'/'null' — truthy, but useless as a
 ** Bearer value. Treat those as no token so the route guards can redirect to login.
 */
const readToken = storage => {
  const token = storage.getItem(STORAGE_TOKEN)

  return !token || token === 'undefined' || token === 'null' ? null : token
}

export const getToken = () => readToken(localStorage) || readToken(sessionStorage)

export const setToken = (token, local = true) => {
  // ** Not every auth response carries a new token (password update returns none), and
  // ** overwriting with an empty value would destroy the session that is still valid
  if (!token || typeof token !== 'string') return

  const storage = getStorage(local)

  storage.setItem(STORAGE_TOKEN, token)
}

export const removeToken = () => {
  localStorage.removeItem(STORAGE_TOKEN)
  sessionStorage.removeItem(STORAGE_TOKEN)
}
export const removeUserInfo = () => {
  localStorage.removeItem('userInfo')
}
